module.exports = __webpack_public_path__ + "static/media/icon_nav_quickstart.ee76b06d.svg";